<template>
  <i18n-t :keypath="'NotificationsComponent.' + notification.type" tag="span" class="pl-quarter" scope="global">
    <template #link>
      <router-link :to="{ name: notification?.params?.url }">{{ tn("AccountLockedOutLink") }}</router-link>
    </template>
  </i18n-t>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { t } from "@/i18n";
import { INotification } from "@/stores/notifications";

const componentName = "AccountLockedOutNotification";

export default defineComponent({
  name: componentName,
  props: {
    notification: {
      type: Object as PropType<INotification>,
      default: null,
    },
  },
  setup() {
    function tn(v: string, params?: Record<string, unknown>): string {
      return t(`${componentName}.${v}`, params);
    }
    return { tn };
  },
});
</script>
